import React, { useState } from "react";
import "./clientSidebar.css";
import QuadrantPage from "./clientComponents/quadrantPage";
import ConsultedUsers from "./clientComponents/ConsultedUsers";
import AddCaseDetails from "./clientComponents/addCaseDetails";
import CaseInfoPage from "./clientComponents/caseInfoPage";
import ListOfCase from "./clientComponents/listOfCase";
import OfficalPage from "./clientComponents/officalPage";
import ReliableAuthorities from "./clientComponents/reliableAuthorities";

const ClientSideBar = () => {
  const [selectedPage, setSelectedPage] = useState("ConsultedUsers");
  

  const renderContent = () => {
    switch (selectedPage) {
      case "ConsultedUsers":
        return <ConsultedUsers setSelectedPage={setSelectedPage}/>;
      case "AddCaseDetails":
        return <AddCaseDetails />;
      case "ListOfCases":
        return <ListOfCase setSelectedPage={setSelectedPage} />;
      case "CaseInfoPage":
        return <CaseInfoPage/>;
      case "reliableAuth":
          return <ReliableAuthorities/>;  
      default:
        return <ConsultedUsers />;
    }
  };

  return (
    <div style={{ display: "flex" }}>
      <div className="sidebarContainer">
        <ul className="submenuClient">
          <li>
            <a
              href="#"
              className="submenuClient-item"
              onClick={(e) => {
                e.preventDefault();  // Prevent page reload
                setSelectedPage("ConsultedUsers");
              }}
            >
              Consulted Users
            </a>
          </li>
          {/* <li>
            <a
              href="#"
              className="submenuClient-item"
              onClick={(e) => {
                e.preventDefault();  // Prevent page reload
                setSelectedPage("AddCaseDetails");
              }}
            >
              Add Case Details
            </a>
          </li> */}
          <li>
            <a
              href="#"
              className="submenuClient-item"
              onClick={(e) => {
                e.preventDefault();  // Prevent page reload
                setSelectedPage("ListOfCases");
              }}
            >
              List of Cases
            </a>
          </li>
          <li>
            <a
              href="#"
              className="submenuClient-item"
              onClick={(e) => {
                e.preventDefault();  // Prevent page reload
                setSelectedPage("reliableAuth");
              }}
            >
              Reliable Authorities
            </a>
          </li>
        </ul>
      </div>

      <div className="contentContainer">{renderContent()}</div>
    </div>
  );
};

export default ClientSideBar;
